<template>
  <header class="checkout-seller">
    <div>
      <figure v-if="disableLink" class="checkout-seller__logo">
        <BaseImage size="100x100" :name="seller.small_logo" :alt="seller.name" />
      </figure>

      <a
        v-else
        :href="pageSellerLink"
        class="checkout-seller__logo"
        @click.prevent="handleOpenSellerPage"
      >
        <BaseImage size="100x100" :name="seller.small_logo" :alt="seller.name" />
      </a>
    </div>

    <div class="checkout-seller__info">
      <p class="checkout-seller__name" :title="seller.name">
        <template v-if="disableLink">
          {{ $t('checkout.seller') }} {{ seller.name }}
        </template>

        <template v-else>
          <span>{{ $t('checkout.seller') }}: </span>
          <a
            :href="pageSellerLink"
            class="link"
            @click.prevent="handleOpenSellerPage"
          >
            {{ seller.name }}
          </a>
        </template>
      </p>

      <p v-if="shipmentCity" class="checkout-seller__shipment">
        <span v-if="!disableLink">{{ $t('checkout.shipment') }}:</span>
        {{ shipmentCity.name }}
      </p>
    </div>
  </header>
</template>

<script setup lang="ts">
import type { ProductOfferSeller } from '~/types/product'
import type { ShipmentCity } from '~/types/seller'

type Props = {
  seller: ProductOfferSeller
  shipmentCity?: ShipmentCity
  disableLink?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  shipmentCity: undefined
})
const commonMetricsStore = useCommonMetricsStore()
const router = useRouter()
const localePath = useLocalePath()

const pageSellerLink = computed(() => {
  return localePath(`/seller/${props.seller.slug}`)
})

const handleOpenSellerPage = () => {
  commonMetricsStore.addMetricEvent({
    element: 'ms[cart-seller-page-link]',
    event_type: 'click',
    event_content: ''
  })
  router.push(pageSellerLink.value)
}

</script>

<style lang="scss" scoped>
.checkout-seller {
  display: flex;

  &__logo {
    flex-shrink: 0;
    display: block;
    width: 4rem;
    height: 4rem;
    margin-right: 1.2rem;
    border-radius: 0.4rem;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &__info {
    max-width: calc(100% - 5.2rem);
  }

  &__name {
    margin-bottom: 0.2rem;
    font-weight: 500;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    > span {
      color: $secondary-font-color;
      font-weight: 400;
    }
  }

  &__shipment {
    line-height: $line-height-18;
    margin-bottom: 0;
    color: $secondary-font-color;
  }
}
</style>
